<template>
  <div class="header px-2 bg-dark">
    <div v-show="showHeaderTitle && !showSearchBarOnly" class="logo display-float">
      <img :src="imageBasePath + admin_cms_logo" alt="" class="site_logo bac_class ml-3">
    </div>
    <div v-show="showHeaderTitle && !showSearchBarOnly" class="ms-3 text-white font-weight-bold"
         style="font-size: 30px">
      {{ company_short_name }} CMS
    </div>
    <div class="flex-grow-1">
      <div v-show="showHeader" class="container">
        <div class="row height d-flex justify-content-center align-items-center">
          <div class="col-md-6">
            <div class="form" @click="turnOnModal">
              <i class="fa fa-search rearrange"></i>
              <input class="form-control form-input" placeholder="Search for menus..."
                     style="background-color: transparent;" type="text" @click="turnOnModal">
              <span class="left-pan"><span class="DocSearch-Button-Keys"><kbd class="DocSearch-Button-Key"><svg
                  class="DocSearch-Control-Key-Icon" height="15" width="15">
                      <path
                          d="M4.505 4.496h2M5.505 5.496v5M8.216 4.496l.055 5.993M10 7.5c.333.333.5.667.5 1v2M12.326 4.5v5.996M8.384 4.496c1.674 0 2.116 0 2.116 1.5s-.442 1.5-2.116 1.5M3.205 9.303c-.09.448-.277 1.21-1.241 1.203C1 10.5.5 9.513.5 8V7c0-1.57.5-2.5 1.464-2.494.964.006 1.134.598 1.24 1.342M12.553 10.5h1.953"
                          fill="none" stroke="currentColor" stroke-linecap="square" stroke-width="1.2"></path>
                    </svg></kbd><kbd class="DocSearch-Button-Key">K</kbd></span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    search modal-->
    <div v-show="showSearchModal">
      <div id="exampleModalFullscreen" ref="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel"
           aria-modal="true" class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
        <div class="modal-dialog">
          <div ref="modalRef" class="modal-content">
            <div class="modal-header" style="margin: 0; padding-left: 0">
              <div class="col-md-10 d-flex flex-row ms-2" style="align-items: center">
                <i class="fa-solid fa-magnifying-glass me-2" style="height: 15px;width: 15px; color: #918f8f"></i>
                <input ref="modal_input" v-model="searchedMenuName" class="search_input flex-grow-1"
                       placeholder="Search for menus" style="border: none; font-size: 16px">
              </div>
              <button aria-label="Close" class="btn" data-bs-dismiss="modal" type="button" @click="turnOffModal">ESC
              </button>
            </div>
            <div class="modal-body" style="height: 60vh; overflow-y: auto;">
              <div class="container">
                <div v-for="(routeInfo, index) in availableRoutes" :key="index" class=" mb-1 flex-grow-1" style="border-bottom: 2px solid #eee;
                             font-size: 15px; font-weight: 500;
                     text-decoration: none">
                  <router-link :to="routeInfo.url" class="without_underline p-3" @click="turnOffModal">
                    {{ routeInfo.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    notification-->
    <div v-if="permissions.SHOW_NOTIFICATIONS == 'Y'" class="dropdown">
      <button aria-expanded="false" class="bell_icon nav-link position-relative rounded-circle shadow-lg "
              data-bs-toggle="dropdown" href="#"
              style="text-decoration: none; color: #2a2929;height: 40px;width: 40px ;"
              type="button">
        <i class="fa-solid fa-bell" style="font-size: large"></i>
        <span class="position-absolute top-0 end-0 badge rounded bg-danger text-md">
          {{ notificationCount }}
        </span>
      </button>
      <ul aria-labelledby="dLabel" class="dropdown-menu notifications" role="menu">
        <div v-if="notificationLoading">
          <b-spinner></b-spinner>
        </div>
        <div v-else>
          <div class="notification-heading">
            <h4 class="menu-title">Notifications</h4>
            <h4 class="menu-title pull-right cursor-pointer text-danger" @click="readAll">Mark all as Read<i
                class="glyphicon glyphicon-circle-arrow-right"></i></h4>
          </div>
          <li class="divider"></li>
          <div v-if="emailList.length > 0" class="notifications-wrapper">
            <router-link v-for="(notice, index) in emailList" :key="index"
                         :to="`/${notice.type == 'post' ? notice.name + '/edit/' + notice.reference_id : 'notification-list'}`"
                         class="content" @click="markSingleNotificationAsRead(notice.id)">
              <div :class="[{ 'notification-item-post': notice.type == 'post' },
    { 'notification-item-portal': notice.type == 'webportal' }, { 'notification-item-mail': notice.type == 'email' }]"
                   class="d-flex flex-row " style="align-items: center;margin-inline: 5px;margin-block: 5px;">
                <div v-if="notice.type == 'post'" class="me-2 notification_icon" style="background-color: #83a2ff;">
                  <i class="fa-solid fa-file-pen" style="height: 15px; width: 15px"></i>
                </div>
                <div v-else-if="notice.type == 'email'" class="me-2 notification_icon"
                     style="background-color: #5cd393;">
                  <i class="fa-solid fa-envelope-open-text" style="height: 15px; width: 15px"></i>
                </div>
                <div v-else class="me-2 notification_icon" style="background-color: #d3925c;">
                  <i class="fa-solid fa-globe" style="height: 15px; width: 15px"></i>
                </div>
                <div class="me-auto">
                  <h4 class="item-title">
                    <span v-if="notice.type == 'post'">
                      New {{ notice.name }} created waiting for approval.
                    </span>
                    <span v-else-if="notice.type == 'webportal'">
                      {{ notice.name }} sent message from web portal.
                    </span>
                    <span v-else-if="notice.type == 'email'">
                      {{ notice.name }} email notification.
                    </span>
                  </h4>
                  <p class="item-info">{{ notice.subject }}</p>
                </div>
                <span class="pull-right" style="font-size: 11px;align-self: flex-end; color: grey;">
                  {{ getDaysAgo(notice.insert_date) }}
                </span>
              </div>
            </router-link>
          </div>
          <div v-else class="text-center" style="font-size: 15px">
            <p>No data found</p>
          </div>
          <li class="divider"></li>
          <div class="notification-footer text-center">
            <router-link class="menu-title text-center" to="/notification-list">See all notifications</router-link>
          </div>
        </div>
      </ul>
    </div>
    <li class="nav-item dropdown" style="align-items: center;font-size: large; list-style:none;">
      <a aria-expanded="false" class="dropdown-toggle nav-link mt-2" data-bs-toggle="dropdown" href="#"
         style="color: wheat; border-radius: 0.5rem; text-decoration: none;padding: 5px 10px"><img :src="avater"
                                                                                                   :style="{ 'width': '30px', 'height': '30px', 'object-fit': 'cover' }"
                                                                                                   alt=""
                                                                                                   class="rounded-circle mx-auto"
                                                                                                   refs="avater">
        {{ this.userData.user_name }}</a>
      <div class="dropdown-menu" data-bs-popper="none" style="font-size: small;">
        <router-link class="nav-link px-0" exact to="/users/profile">Profile</router-link>
        <router-link class="nav-link px-0" exact to="/users/change-password">Change Password</router-link>
        <a class="nav-link px-0" style="cursor: pointer;" @click="logOut">Log Out</a>
      </div>
    </li>
  </div>
</template>

<script>
import UserService from '@/services/user.service.js';
import DashboardService from '@/services/dashboard.service.js';
import userHistoryService from '@/services/user-history.service';
import SystemSettingsService from '@/services/system-settings.service';
import permissionService from '@/services/permission.service';
import Config from '@/config/index';
import moment from 'moment';
import {notify} from '@kyvg/vue3-notification'


export default {
  name: 'HeaderPage',
  props: ['showHeaderTitle', 'index', 'showSearchBarOnly'],
  data() {
    return {
      showSearchModal: false,
      availableRoutes: [],
      backupRoutes: [],
      searchedMenuName: '',
      imageBasePath: null,
      permissions: {},
      user: [],
      notificationCount: 0,
      userData: [],
      notificationData: {},
      emailList: [],
      system_settings: null,
      company_short_name: null,
      admin_cms_logo: null,
      notificationLoading: false,
      showHeader: true,
      avater: Config.apiFileBasePath + "/media/image/2024/no-photo_24020517401315.jpg",
    };
  },
  watch: {
    searchedMenuName(data) {
      if (data != '' && data != null) {
        this.availableRoutes = this.backupRoutes.filter(route => {
          return route.title.toLowerCase().includes(data.toLowerCase());
        })
      } else {
        this.availableRoutes = this.backupRoutes;
      }
    }
  },
  async mounted() {
    this.showHeader = localStorage.getItem('show_cms_search_bar') == 'Y' ? true : false;
    window.addEventListener('show_cms_search_bar_storage_changed', (event) => {
      this.showHeader = event.detail.storage == 'Y' ? true : false;
    });
    await this.getPermissions();
    this.permissions = JSON.parse(localStorage.getItem("permissions"));

    if (this.permissions == null) {
      this.permissions = {};
    }
    let self = this;
    window.addEventListener('keydown', function (e) {
      self.myMethod(e);
    });

  },
  async created() {
    this.imageBasePath = Config.apiFileBasePath;
    await this.getSystemSettings();
    this.getUserData();
    await this.getNotificationData();
    // setInterval(() => {
    this.getNotificationCount();
    this.availableRoutes = JSON.parse(localStorage.getItem('permitted_routes_with_names'));
    this.backupRoutes = this.availableRoutes;
    // }, 600)
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    turnOnModal() {
      this.availableRoutes = JSON.parse(localStorage.getItem('permitted_routes_with_names'));
      this.backupRoutes = this.availableRoutes;
      this.showSearchModal = true;
      document.addEventListener('mouseup', this.closeModalOnClickOutside);
      this.$refs.modal_input.focus();
    },
    turnOffModal() {
      this.showSearchModal = false;
      this.availableRoutes = this.backupRoutes;
      this.searchedMenuName = '';
      document.removeEventListener('mouseup', this.closeModalOnClickOutside);
    },
    closeModalOnClickOutside(event) {
      const modal = this.$refs.modalRef;
      if (!modal.contains(event.target)) {
        this.turnOffModal();
      }
    },
    myMethod(e) {
      if (e.key === "k" && (e.ctrlKey || e.metaKey) && this.showHeader) {
        e.preventDefault();
        this.turnOnModal();
      } else if (e.key === "Escape" && this.showHeader) {
        e.preventDefault();
        this.turnOffModal();
      }
    },
    getNotificationCount() {
      this.notificationCount = JSON.parse(localStorage.getItem("EmailCount"));
    },
    async readAll() {
      const response = await DashboardService.updateNotificationStatusData();
      if (response.data.messageCode == 1) {
        await this.getNotificationData();
      }
    },
    async getNotificationData() {
      this.notificationLoading = true;

      try {
        const response = await DashboardService.getNotificationData();
        this.notificationLoading = false;

        if (response.data) {
          this.notificationData = await DashboardService.getNotificationData();
          this.emailList = this.notificationData.data.emailNotifications;
          this.notificationCount = this.notificationData.data.count;
          localStorage.setItem("EmailCount", JSON.stringify(this.notificationData.data.count));
        }
      } catch (error) {
        this.notificationLoading = false;
        notify({
          type: 'error',
          title: 'Error',
          text: error,
        });
      }

    },

    getDaysAgo(date) {
      //s const currentDate = moment();
      const targetDate = moment(date);

      const daysAgoString = targetDate.fromNow(true);

      return daysAgoString + ' ago';
    },

    sendToPage() {
      if (this.notificationCount > 0) {
        //this.$router.push("/notification-list");
        localStorage.removeItem("EmailList");
        localStorage.setItem("EmailList", JSON.stringify(this.emailList));
      } else {
        localStorage.removeItem("EmailList");
      }
    },

    async getUserData() {
      this.userData = await UserService.getUserById();
      if (this.userData.profile_image !== null) {
        const imageData = "data:" + this.userData.profile_image_type + ";base64, " + this.userData.profile_image;
        this.avater = imageData;
      } else {
        this.avater = Config.apiFileBasePath + "/media/image/2024/no-photo_24020517401315.jpg";
      }

    },

    async getPermissions() {
      this.permissions = await permissionService.getUserPermissions();
    },
    async getSystemSettings() {
      try {
        const response = await SystemSettingsService.getSystemSettings();
        if (response.data) {
          this.system_settings = response.data;
          const adminCmsLogoObj = response.data.find(item => item.system_key === "admin_cms_logo");
          this.admin_cms_logo = adminCmsLogoObj ? adminCmsLogoObj.value : null;
          const company_short_name_obj = response.data.find(item => item.system_key === "company_short_name");
          this.company_short_name = company_short_name_obj ? company_short_name_obj.value : null;
          const show_cms_search_bar_obj = response.data.find(item => item.system_key === "show_cms_search_bar");
          localStorage.setItem("show_cms_search_bar", show_cms_search_bar_obj ? show_cms_search_bar_obj.value : "N");
          this.showHeader = show_cms_search_bar_obj ? show_cms_search_bar_obj.value == 'Y' ? true : false : false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async markSingleNotificationAsRead(notificationId) {
      const response = await DashboardService.markSingleNotificationAsRead(notificationId);
      if (response.data) {
        if (response.data.messageCode == 1) {
          await this.getNotificationData();
        } else {
          notify({
            type: 'error',
            title: 'Error',
            text: response.data.message,
          });
        }
      } else {
        notify({
          type: 'error',
          title: 'Error',
          text: "Notification could not be read",
        });
      }
    },

    async logOut() {
      this.$swal({
        icon: "question",
        // position: "top-end",
        title: 'Are you sure, You want to Log Out?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#dd3333',
        showConfirmButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#007bff',
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem('permissions');
          userHistoryService.saveBeforeLogout({'user_id': this.userData.user_id});
          this.$store.dispatch('auth/logout');
          // this.$router.push('/');
        }
      });
      // if () {
      //   const response = await userHistoryService.saveBeforeLogout({ 'user_id': this.userData.user_id });
      //   console.log(response);
      //   this.$store.dispatch('auth/logout');
      //   this.$router.push('/');
      // } else {
      //   return;
      // }
    }
  },
  // components: { RouterLink }
};
</script>

<style>
.bac_class {
  background-color: white;
  border-radius: 5px;
}

.nav-link {
  border-radius: 0 !important;
}

/* CSS used here will be applied after bootstrap.css */

.dropdown {
  display: inline-block;
  padding: 10px 0px;
}


.glyphicon-bell {

  font-size: 1.5rem;
}

.notifications {
  min-width: 420px;
}

.notifications-wrapper {
  overflow: auto;
  max-height: 250px;
}

.menu-title {
  color: #000000;
  font-size: 15px;
  display: inline-block;
  font-weight: 500;
}

.glyphicon-circle-arrow-right {
  margin-left: 10px;
}


.notification-heading,
.notification-footer {
  padding: 2px 10px;
}


.dropdown-menu.divider {
  margin: 5px 0;
}

.item-title {

  font-size: 1.3rem;
  color: #000;

}

.notifications a.content {
  text-decoration: none;
  background: #ccc;
  filter: none;

}

.pull-right {
  float: right;
}

.bell_icon {
  background-image: linear-gradient(180deg, #cccccc 10%, #cacaca 100%);
}

.notification-item {
  padding: 10px;
  margin: 1px;
  background: #f1f1f1b3;
  border-radius: 4px;
}

.notification-item-mail {
  padding: 10px;
  margin: 1px;
  border-radius: 10px;
  background: rgba(224, 236, 230, 0.6);

}

.notification-item-post {
  padding: 10px;
  margin: 1px;
  border-radius: 10px;
  background: #ebeef6;
}

.notification-item-portal {
  padding: 10px;
  margin: 1px;
  border-radius: 10px;
  background: #f6f1eb;
}

.notification_icon {
  display: flex;
  color: white;
  border: black;
  border-radius: 15px;
  height: 30px;
  width: 30px;
  align-items: center;
  justify-content: center
}


.form {
  position: relative;
}

.without_underline {
  border: 0;
  box-shadow: none;
  color: black;
  display: block;
}

.without_underline:hover {
  background-color: #ecedf5;
  text-decoration: none;
  color: black;
  filter: none;
}

.without_underline.active {
  color: black !important;
  box-shadow: none;
  border: none;
}

.search_input:focus {
  border: none;
  outline: none;
}

.form .rearrange {
  position: absolute;
  top: 17px;
  left: 15px;
  color: #9ca3af;
}


.form .left-pan {
  position: absolute;
  right: 8px;
  top: 11px;
  padding: 1px;
}

.left-pan {
  padding-left: 7px;
}

.left-pan i {

  padding-left: 10px;
}

.form .form-input {
  height: 45px !important;
  text-indent: 33px;
  border-radius: 10px;
  background: transparent;
}

.DocSearch-Button-Keys {
  min-width: 0;
  padding: 0.125rem 0.25rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 0;
}

.DocSearch-Button-Keys {
  display: flex;
}
</style>
